import React from 'react';

import { ReactComponent as NotFound } from '../../../assets/logos/not_found.svg';
import { Button, Layout } from '../../../components';
import useRedirect from '../../../hooks/useRedirect';
import { RoutesPaths } from '../../../routes';
import { GridContainer, Grid, RightGrid } from './styles';

export const SessionExpired: React.FC = () => {
  const redirect = useRedirect();

  return (
    <>
      <Layout
        headerProtect
        hideFloatingButton
        hideFooter
        hideBackbar
        hideInstructionModal
        titlePage={'Erro Interno'}
      >
        <GridContainer>
          <Grid>
            <NotFound />
          </Grid>
          <Grid>
            <RightGrid>
              <h2>Sessão Expirada!</h2>

              <p>
                O tempo da sua sessão expirou, por favor entre novamente com
                seus dados para que possamos autenticar seu acesso.
              </p>
              <div>
                <Button
                  variant="solid"
                  onClick={() => {
                    redirect(RoutesPaths.login);
                  }}
                >
                  Entendi
                </Button>
              </div>
            </RightGrid>
          </Grid>
        </GridContainer>
      </Layout>
    </>
  );
};
